module.exports = __webpack_public_path__ + "static/media/event_tab_add.6eef7efd.svg";